import React, { useEffect } from 'react';
import BannerCarousel from './BannerCarousel';
import HtmlTextArea from './HtmlTextArea';
import FruitCardCarousel from './FruitCardCarousel';
import ImageHeader from './ImageHeader';
import IconComponent from './IconComponent';
import FruitCardList from './FruitCardList';
import PackagingComponent from './PackagingComponent';
import ImageContainer from './ImageContainer';
import VideoComponent from './VideoComponent';
import FarmerTestimonials from './FarmerTestimonialsComponent';
import FruitTrail from './FruitTrail';


function PageRenderer(props) {
   

    let arrCntList = [];

    function getControlType(FldMapping, fldValue, FldID) {
       
        let cntType = null;
        switch (FldMapping) {
            case 1:
                if (FldID == 42) {
                    cntType = <IconComponent data={fldValue}></IconComponent>
                } else if (FldID == 10) {
                    cntType = <VideoComponent data={fldValue}></VideoComponent>
                }

                break;
            case 3:
                if (FldID == 7 || FldID == 49 || FldID == 48) {
                    cntType = <ImageHeader data={fldValue} FldMapType={FldID} ></ImageHeader>
                } else if (FldID == 9 || FldID == 8) {
                    cntType = <ImageContainer data={fldValue} FldMapType={FldID} ></ImageContainer>
                } else {

                }
                break;

            case 4:
                if (FldID == 15) {
                    cntType = <PackagingComponent data={fldValue}></PackagingComponent>
                } else {

                }
                break;

            case 9:
                if (FldID == 11) {

                    cntType = <FarmerTestimonials data={fldValue}></FarmerTestimonials>
                }
                break;

            case 10:
                cntType = <HtmlTextArea data={fldValue}></HtmlTextArea>
                break;
            case 11:
                if (FldID == 47) {
                    cntType = <FruitTrail data={fldValue}></FruitTrail>
                } else {
                    cntType = <BannerCarousel data={fldValue}></BannerCarousel>
                }
                break;
            case 12:
                if (FldID == 44) {
                    cntType = <FruitCardList data={fldValue} FldMapType={FldID} ></FruitCardList>

                } else {
                    cntType = <FruitCardCarousel data={fldValue} FldMapType={FldID}></FruitCardCarousel>
                }
                break;
            default:
                break;
        }
        return cntType;
    }


    for (var key in props.data.ContentJson) {
        let fldValue: string = props.data.ContentJson[key];
        let arrKeyParams = key.split('_');
        let fldControl = parseInt(arrKeyParams[2]);
        let fld = parseInt(arrKeyParams[3]);
        let fldMapID = parseInt(arrKeyParams[4]);
        let cntType = getControlType(fldControl, fldValue, fld);
        if (cntType != null) {
            arrCntList.push(cntType);
        }

    }

    return (
        <div className='container-fluid' >
            {
                arrCntList.length > 0 && arrCntList.map((item, index) => (
                    <React.Fragment key={index}>{item}</React.Fragment>
                ))
            }
        </div>
    );
}

export default PageRenderer;
